import {Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {IoptionElemet} from "../../../shared/interfaces/IoptionElemet";
import {Observable} from "rxjs/Rx";
import { PlaceholderChildComponent, ICloseReturnType } from '@ispm/layout/classes/placeholder-child-component.abstract';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';

@Component({
  selector: 'gen-add-curation',
  templateUrl: './add-curation.component.html',
  styleUrls: ['./add-curation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddCurationComponent extends PlaceholderChildComponent implements OnInit {
  public payload: {formName: string, aberrationType: string, options: IoptionElemet[]};
  public tunnel$: Subject<any>;
  public callback: (model) => Observable<Response>;
  public selectedFormName: string;
  public form: any;
  public submitted: boolean;
  private isValid: boolean;
  public curationType: string;

  constructor(private changeDetector:ChangeDetectorRef){
    super()
  }

  beforeClose(_modalResponse?: modalResponse): void | ICloseReturnType {
    // switch(_modalResponse){
    //   case modalResponse.approve:
    //   return {isValid: this.isValid};
    // }
  }

  ngOnInit() {
    //super.ngOnInit();
    this.selectedFormName = this.payload.formName;
    this.tunnel$.asObservable().filter(value => value.emitter !== 'child').subscribe(next => {
      next.value && this.submit(this.payload);
    });
  }

  submit(model) {
    if(this.submitted){
      return;
    }
    this.submitted = true;
    this.changeDetector.markForCheck(); // need to be called in a modal form
    if (!this.isValid) {
      return;
    }

    model = this.form;
    model = this.getDataFromFormTempFunc(model);

    if(this.submitted && this.isValid) {
      this.callback(model).subscribe((model) => {
        this.tunnel$.next({emitter: 'child', value: model});
      });
    }
  }

  private getDataFromFormTempFunc(model) {
    for (const key in model) {
      if (model[key] == '' || model[key] == null) {
        delete model[key];
      }
    }
    return model;
  }

  updateValidate(validate: boolean) {
    const submittedWhileInvalid = this.submitted && !this.isValid;
    if (submittedWhileInvalid) {
      this.submitted = false;
    }
    this.isValid = validate;
  }

  updateForm($event) {
    this.form = $event;
  }
}
